export const kGlobalConstants = {
    API: 'https://broker-api.usaspending.gov/v1/',
    CAS_ROOT: 'https://login.max.gov',
    CAIA_ROOT: 'https://caia.treasury.gov',
    CAIA_CLIENT: '923a139d-077b-41ba-ab6c-1af184c4bca0',
    AUTH_CALLBACK: 'https://broker.usaspending.gov/auth',
    PUBLIC_FILES: 'https://files-broker.usaspending.gov/samples/',
    GA_TRACKING_ID: 'UA-60737492-2',
    LOCAL: false,
    DEV: false,
    PROD: true
    
};
